import gql from 'graphql-tag';
import moment from 'moment-timezone';

const getOrgHighestEngagementsQuery = gql`
  query GetOrgHighestEngagements(
    $createdAt: [String], 
    $organisationId: String!,
    $productShortName: String!, 
    $timezone: String!
  ) {
    getOrgHighestEngagements(
      createdAt: $createdAt,
      organisationId: $organisationId,
      productShortName: $productShortName,
      timezone: $timezone
    ) {
      stats
    }
  }
`;

const queryGetOrgHighestEngagements = (organisationId) => ({
  query: getOrgHighestEngagementsQuery,
  module: 'analytics',
  buildVariables: (data) => {
    const {
      createdAt,
      productShortName,
      timezone = moment.tz.guess()
    } = data;
    return {
      createdAt,
      organisationId,
      productShortName,
      timezone
    };
  }
});

export default queryGetOrgHighestEngagements;